/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvaGFtYWRhL0RvY3VtZW50cy9naXRfdmVyaWZ5L2t1cnVtYWppdGVuX2FvdC9rdXJ1bWFqaXRlbi9zcmMvYXBwL2xvZ2luL3ZhbGlkYXRpb24tbWVzc2FnZS92YWxpZGF0aW9uLW1lc3NhZ2UuY29tcG9uZW50LmNzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9DOi9Vc2Vycy9oYW1hZGEvRG9jdW1lbnRzL2dpdF92ZXJpZnkva3VydW1haml0ZW5fYW90L2t1cnVtYWppdGVuL3NyYy9hcHAvbG9naW4vdmFsaWRhdGlvbi1tZXNzYWdlL3ZhbGlkYXRpb24tbWVzc2FnZS5jb21wb25lbnQuY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/login/validation-message/validation-message.component.css.shim.ngstyle.ts